/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kiotviet_Link_Confirm_SubmitInputs */

const vi_kiotviet_link_confirm_submit = /** @type {(inputs: Kiotviet_Link_Confirm_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vẫn nối lại`)
};

/**

* @param {Kiotviet_Link_Confirm_SubmitInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const kiotviet_link_confirm_submit = /** @type {((inputs?: Kiotviet_Link_Confirm_SubmitInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kiotviet_Link_Confirm_SubmitInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_kiotviet_link_confirm_submit(inputs)
});